// extracted by mini-css-extract-plugin
export default {"criteria-chips":"FilterChips_criteria-chips__vHbfq","explanation":"FilterChips_explanation__4gYwc"};